<template>
  <div>
    <ul>
      <hr />
      <li v-for="(incentive, index) in incentives" :key="index">
        <span v-for="(data, index2) in incentive.payload.data" :key="index2">
          <incentives-and-rebates-card
            :message="data.name"
            :expiry="data.expiry"
            :value="data.value"
            :type="data.valueType"
          ></incentives-and-rebates-card>
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import IncentivesAndRebatesCard from '@/modules/spotlight/components/categories/incentives-and-rebates/IncentivesAndRebatesCard.vue';

export default {
  name: 'incentivesAndRebates',
  components: {
    IncentivesAndRebatesCard,
  },
  computed: {
    ...mapGetters('spotlight', ['getSpotlightCategories']),
    incentives() {
      return (
        this.getSpotlightCategories.find(
          payload => payload.category === this.enums.SpotlightConstants.categories.INCENTIVES_AND_REBATES
        )?.spotlights || []
      );
    },
  },
};
</script>

<style scoped lang="scss">
.disclaimer {
  font-size: 14px;
  color: rgb(75, 88, 99);
  padding-bottom: 24px;
}
hr {
  color: #dae2ea;
}

ul {
  list-style-type: none;
  padding-left: 0;
}
</style>
